/* @flow */
import * as React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import CenteredContainer from 'components/CenteredContainer';
import Columns2 from 'components/Columns2';
import EventTracking from 'lib/EventTracking';
import Group from 'entities/Group';
import GroupName from 'groups/components/GroupName';
import JoinGroupFormPanel from './JoinGroupFormPanel';
import JoinGroupAvatarPanel from './JoinGroupAvatarPanel';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
import { withRouter } from 'app/context/Router';

import GroupDataOps from 'groups/lib/GroupDataOps';
import type { LoadNonV2GroupByCode_groupsByCode } from 'groups/queries/__generated__/LoadNonV2GroupByCode';

import './styles/JoinGroupPage.scss';

type Props = {
  groupJson: ?LoadNonV2GroupByCode_groupsByCode,
  loading: boolean,
};

class JoinGroupPage extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('join_group_page.sign_up.view');
  }

  render() {
    const { groupJson } = this.props;

    // XXX - This is to fix https://my.trackjs.com/details/9a7be15d01bd4ae98c41d04c4148a8aa.
    // Somehow we're ending up with an empty groupJson here sometimes
    if (GroupDataOps.hasIdOrUuid(groupJson) === false) {
      console.warn('Trying to render an empty group');
      return null;
    }

    return (
      <CenteredContainer size="large">
        <Box>
          <BoxBody>
            <TitleHeader
              title={
                <span>
                  Join {GroupDataOps.getPossessiveSignature(groupJson)}
                  <Text element="div" weight="semibold">
                    <GroupName group={groupJson} />
                  </Text>
                </span>
              }
              subtext={GroupDataOps.getOrganizationName(groupJson)}
              className="JoinGroupPage-title"
            />
            <Columns2 flex reset="tablet" resetFlush>
              <div>
                <JoinGroupAvatarPanel group={groupJson} className="JoinGroupPage-header" />
              </div>
              <JoinGroupFormPanel group={groupJson} />
            </Columns2>
          </BoxBody>
        </Box>
      </CenteredContainer>
    );
  }
}

type ConnectJoinGroupState = {
  groupJson?: LoadNonV2GroupByCode_groupsByCode,
  loading: boolean,
};

// TEMP until we can get this by GraphQL
function withGroup(WrappedComponent) {
  return class ConnectJoinGroupPage extends React.Component<
    $FlowFixMeProps,
    ConnectJoinGroupState
  > {
    state = {
      groupJson: undefined,
      loading: true,
    };

    componentDidMount() {
      const { router } = this.props;
      const { groupCode } = router.params;

      const cleanGroupCode = GroupDataOps.parseAcceptableGroupCode(groupCode);

      if (cleanGroupCode) {
        Group.fetchByCode(cleanGroupCode).then(
          group => {
            if (GroupDataOps.canJoin(group)) {
              this.setState({ groupJson: group, loading: false });
            } else {
              router.replace('/error');
              throw new Error('Cannot join group');
            }
          },
          err => {
            console.warn('error loading group', err);
            router.replace(`/join?notFound=${groupCode}`);
          }
        );
      } else {
        router.replace(`/join?notFound=${groupCode}`);
        throw new Error('invalid group code');
      }
    }

    render() {
      if (this.state.loading) {
        return <b>Loading…</b>;
      }
      return <WrappedComponent {...this.props} {...this.state} />;
    }
  };
}
export default withRouter(withGroup(JoinGroupPage));
